



















import stepHeader from "../create/components/stepHeader.vue";
import engagePopover from "../components/engagePopover.vue";
// @ts-ignore
import lists from "./lists/lists";
// @ts-ignore
import useContacts from "@/views/modules/contacts/useContacts";
// @ts-ignore
import vSelect from "vue-select";
import { BButton, BCol, BContainer, BPopover, BRow } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
// @ts-ignore
import router from "@/router";

export default {
    components: {
        BButton,
        BCol,
        BContainer,
        BPopover,
        BRow,
        lists,
        vSelect,
        stepHeader,
        engagePopover,
    },

    setup() {
        const refTable = ref(null);
        const { count } = useContacts();

        /**
         * Popover info
         */
        const popoverShow = ref(false);
        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        return {
            count,
            onPopoverClose,
            popoverShow,
            refTable,
            route: router.currentRoute.name,
        };
    },
};
